module.exports = __webpack_public_path__ + "img/close.d1f7b8b8.svg";